var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#009EE3;}\n\t.st1{fill:#F5B501;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.9,99.8H11.6V8.2l80.7,9.5L41.9,99.8z M13.3,98.1h27.6l48.4-79l-76-8.9C13.3,10.2,13.3,98.1,13.3,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.9,100H46.7l50.2-82.8V100z M49.8,98.3h45.4V23.4L49.8,98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.9,99.8H11.3l20.1-71.7l61.1-11L41.9,99.8z M13.6,98.1H41l48-78.5l-56.2,10L13.6,98.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "3.7,98.6 3.1,0 91.7,10.8 91.5,12.5 4.9,2 5.4,98.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "90,92.2 53,92.2 53,90.4 88.2,90.5 88.2,53.9 90,53.9  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.88016c0f04bc36d19ff41e40f81acf8d.svg";
export { ForwardRef as ReactComponent };